// extracted by mini-css-extract-plugin
export default {"top_shifter_whith_header":"top_shifter_top_shifter_whith_header__7SXG8","top_shifter_whithout_header":"top_shifter_top_shifter_whithout_header__tvDl7"};